import { Component } from 'react';

// material-ui
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import MainCard from 'components/MainCard';

/**
 * Catches JavaScript errors in the child tree (render/lifecycle), not router errors.
 */
export default class ReactErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            bgcolor: 'background.default'
          }}
        >
          <Box sx={{ maxWidth: 420, width: '100%' }}>
            <MainCard>
              <Stack spacing={2} sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h5" color="error">
                  Something broke
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
                  {error.message}
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => {
                    window.location.href = import.meta.env.BASE_URL || '/';
                  }}
                  sx={{ alignSelf: 'center' }}
                >
                  Go to app home
                </Button>
              </Stack>
            </MainCard>
          </Box>
        </Box>
      );
    }

    return children;
  }
}
